export default {
    topics: [
        {
            title: ' appendData ',
            href: 'm-DOMCharacterData-appendData.html',
            attributes: { 'data-id': 'm-DOMCharacterData-appendData' },
            menu: { hasChildren: false },
            tocID: 'm-DOMCharacterData-appendData-d66e7499',
            topics: [],
        },
        {
            title: ' data ',
            href: 'p-DOMCharacterData-data.html',
            attributes: { 'data-id': 'p-DOMCharacterData-data' },
            menu: { hasChildren: false },
            tocID: 'p-DOMCharacterData-data-d66e7507',
            topics: [],
        },
        {
            title: ' deleteData ',
            href: 'm-DOMCharacterData-deleteData.html',
            attributes: { 'data-id': 'm-DOMCharacterData-deleteData' },
            menu: { hasChildren: false },
            tocID: 'm-DOMCharacterData-deleteData-d66e7515',
            topics: [],
        },
        {
            title: ' insertData ',
            href: 'm-DOMCharacterData-insertData.html',
            attributes: { 'data-id': 'm-DOMCharacterData-insertData' },
            menu: { hasChildren: false },
            tocID: 'm-DOMCharacterData-insertData-d66e7523',
            topics: [],
        },
        {
            title: ' length ',
            href: 'p-DOMCharacterData-length.html',
            attributes: { 'data-id': 'p-DOMCharacterData-length' },
            menu: { hasChildren: false },
            tocID: 'p-DOMCharacterData-length-d66e7531',
            topics: [],
        },
        {
            title: ' replaceData ',
            href: 'm-DOMCharacterData-replaceData.html',
            attributes: { 'data-id': 'm-DOMCharacterData-replaceData' },
            menu: { hasChildren: false },
            tocID: 'm-DOMCharacterData-replaceData-d66e7539',
            topics: [],
        },
        {
            title: ' substringData ',
            href: 'm-DOMCharacterData-substringData.html',
            attributes: { 'data-id': 'm-DOMCharacterData-substringData' },
            menu: { hasChildren: false },
            tocID: 'm-DOMCharacterData-substringData-d66e7547',
            topics: [],
        },
    ],
};

